export default "__VITE_ASSET__owfa6gDI__"